module.exports = __webpack_public_path__ + "7e9d1894a203e22f33b9e063c19a7eea.pdf";